import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const PathNotifier = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    if (window.AndroidInterface && window.AndroidInterface.sendPathToAndroid) {
      window.AndroidInterface.sendPathToAndroid(currentPath);
    }

    console.log("Current path:", currentPath);
  }, [location]);

  return null;
};

export default PathNotifier;
